import { Component, OnInit, Input } from "@angular/core";
import { SessionService } from "../services/session.service";
import { DomSanitizer } from "@angular/platform-browser";
import { environment } from "src/environments/environment";
import { ActivatedRoute } from "@angular/router";
import {Location} from '@angular/common';
import { LoginService } from '../services/login.service';

@Component({
  selector: "app-iframe-bo",
  templateUrl: "./iframe-bo.component.html",
  styleUrls: ["./iframe-bo.component.scss"],
})
export class IframeBoComponent implements OnInit {
  srcIframe;
  @Input() page: string;
  parameter;
  constructor(
    private sessionService: SessionService,
    private sanitizer: DomSanitizer,
    private route: ActivatedRoute,
    private location: Location,
    private loginService : LoginService,
  ) {
    if (window.addEventListener) {
      window.addEventListener("message", this.receiveMessage.bind(this), false);
    } else {
       (<any>window).attachEvent("onmessage", this.receiveMessage.bind(this));
    }
  }

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      this.parameter = +params["id"];
    });

    const { businessId, page } = this.route.snapshot.params;

    if (page) {
      this.page = page;
    }
    const url = window.location.href;
    if (
      url.includes("user") ||
      url.includes("company") ||
      url.includes("businesses") ||
      url.includes("task")
    ) {
      const args = url.split("/");
      if (+args[args.length - 1] && !this.parameter && !businessId) {
        this.parameter = +args[args.length - 1];
      }
    }

    const urlBo = `${environment.boUrl}?userId=${this.sessionService.currentUserValue.user.id}&userEmail=${this.sessionService.currentUserValue.user.email}&sessionToken=${this.sessionService.currentUserValue.token}&sessionRefreshToken=${this.sessionService.currentUserValue.refreshToken}#!/${this.page}`;

    if (this.parameter) {
      this.srcIframe = this.sanitizer.bypassSecurityTrustResourceUrl(
        `${urlBo}/${this.parameter}`
      );
    } else if (businessId) {
      this.srcIframe = this.sanitizer.bypassSecurityTrustResourceUrl(
        `${urlBo}/${businessId}`
      );
    } else {
      this.srcIframe = this.sanitizer.bypassSecurityTrustResourceUrl(urlBo);
    }
  }

  receiveMessage(event: any) {
    const boUrlOrigin = new URL(environment.boUrl).origin

    if (event.origin !== boUrlOrigin) {
      return;
    }

    if(!event.data) {
      console.error(`O recurso do BO (${environment.boUrl}) que está sendo acessado não foi mapeado!`);
    } else {
      const { data: resourceFromBo } = event;

      if(resourceFromBo.type === 'LOGOUT')
        return this.loginService.logout()

      if(resourceFromBo.type === 'REFRESH_TOKEN'){
        return this.sessionService.setSession(resourceFromBo)
}
      this.location.replaceState(resourceFromBo);
    }
  }
}
